import { render, staticRenderFns } from "./AdminLoginPage.vue?vue&type=template&id=5cae5c33&"
import script from "./AdminLoginPage.vue?vue&type=script&lang=js&"
export * from "./AdminLoginPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports